export default{
    backend: "https://api.dilibit.com/api/v1/",
    img: "https://api.dilibit.com/img/",
}
/*
backend: "https://apitest.dilibit.com/api/v1/"
backend: "https://api.dilibit.com/api/v1/"
*/
